import { providers } from '../../providers';
import { volcengine } from '../volcengine';
import { baidu } from '../baidu';
import { tencent } from '../tencent';
import { dimensio } from '../dimensio';
import { cool } from '../cool';
import { getUiOptionsForModel } from '../ui-options';
import type { VideoModelEntry } from '../types';
import { rmbCost480p, usdCost480p, rmbCost720p, usdCost720p, rmbCost1080p, usdCost1080p, rmbCost4k, usdCost4k, rmbRefCost480p, usdRefCost480p, rmbRefCost720p, usdRefCost720p, rmbRefCost1080p, usdRefCost1080p, rmbRefCost4k, usdRefCost4k, rmbCost480pFast, usdCost480pFast, rmbCost720pFast, usdCost720pFast, rmbRefCost480pFast, usdRefCost480pFast, rmbRefCost720pFast, usdRefCost720pFast, rmbCost480pMini, usdCost480pMini, rmbCost720pMini, usdCost720pMini, rmbRefCost480pMini, usdRefCost480pMini, rmbRefCost720pMini, usdRefCost720pMini, } from './seedance-pricing';

// 系数
const COST_FACTOR = 1.5;

// Seedance 2.5 系数
const SEEDANCE_2_5_COST_FACTOR = 1.5;

export const volcengineModels: VideoModelEntry[] = [
    {
        id: 'seedance-2.5',
        chef: providers.bytedance,
        frameModeLabels: { ref: 'Omni Reference' },
        providers: [
            {
                ...providers.bytedance,
                model: dimensio('seedance-2.5'),
                modelBackup: [baidu('seedance-2.5-api-real'), volcengine('seedance-2.5-api')],
                // 积分: 美元
                getCost: ({ duration, quality, providerOptions }) => {
                    const inputDur = providerOptions?._media?.videoDurationSeconds ?? 0;
                    const totalDur = duration + inputDur;
                    if (inputDur > 0) {
                        if (quality === '480p') return totalDur * usdRefCost480p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                        if (quality === '720p') return totalDur * usdRefCost720p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                        if (quality === '1080p') return totalDur * usdRefCost1080p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                        return totalDur * usdRefCost1080p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                    } else {
                        if (quality === '480p') return totalDur * usdCost480p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                        if (quality === '720p') return totalDur * usdCost720p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                        if (quality === '1080p') return totalDur * usdCost1080p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                        return totalDur * usdCost1080p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                    }
                },
                // 积分: 人民币
                getPassCount: ({ duration, quality, providerOptions }) => {
                    const inputDur = providerOptions?._media?.videoDurationSeconds ?? 0;
                    const totalDur = duration + inputDur;
                    if (inputDur > 0) {
                        if (quality === '480p') return totalDur * rmbRefCost480p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                        if (quality === '720p') return totalDur * rmbRefCost720p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                        if (quality === '1080p') return totalDur * rmbRefCost1080p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                        return totalDur * rmbRefCost1080p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                    } else {
                        if (quality === '480p') return totalDur * rmbCost480p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                        if (quality === '720p') return totalDur * rmbCost720p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                        if (quality === '1080p') return totalDur * rmbCost1080p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                        return totalDur * rmbCost1080p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                    }
                },
            },
        ],
        configByMode: {
            none: {
                aspectRatios: ['9:16', '3:4', '1:1', '4:3', '16:9', '21:9'],
                durations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30],
                qualities: ['480p', '720p', '1080p'],
                inlineMedia: {
                    image: { allow: false },
                    video: { allow: false },
                    audio: { allow: false },
                },
            },
            first: {
                aspectRatios: [],
                durations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30],
                qualities: ['480p', '720p', '1080p'],
                inlineMedia: {
                    image: { allow: true, maxCount: 1, maxSize: '30MB', formats: ['image/png', 'image/jpeg'] },
                    video: { allow: false },
                    audio: { allow: false },
                },
            },
            first_last: {
                aspectRatios: [],
                durations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30],
                qualities: ['480p', '720p', '1080p'],
                inlineMedia: {
                    image: { allow: true, maxCount: 2, maxSize: '30MB', formats: ['image/png', 'image/jpeg'] },
                    video: { allow: false },
                    audio: { allow: false },
                },
            },
            ref: {
                aspectRatios: ['match', '9:16', '3:4', '1:1', '4:3', '16:9', '21:9'],
                durations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30],
                qualities: ['480p', '720p', '1080p'],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 30, maxSize: '30MB', formats: ['image/png', 'image/jpeg'] },
                    video: { allow: true, maxCount: 10, maxSize: '200MB', minDuration: '2s', maxDuration: '30s', minPixels: 409600, maxPixels: 8295044, formats: ['video/mp4', 'video/quicktime'] },
                    audio: { allow: true, maxCount: 10, maxSize: '15MB', minDuration: '2s', maxDuration: '30s', formats: ['audio/mpeg', 'audio/wav'] },
                    mediaDurationLimit: { enabled: true, maxTotalDuration: '30s' },
                    maxMediaCount: 20,
                    maxTotalCount: 50,
                },
            },
        },
        precheckByMode: {
            none: ['prompt'],
            first: ['prompt', 'image'],
            first_last: ['prompt', 'image2'],
            ref: ['prompt', 'image|video|audio'],
        },
        supportsEdit: true,
        supportsInput: ['t2v','first','first_last', 'reference'],
        priceIndicator: 'lowest',
        price: 'Dynamic',
        uiOptions: getUiOptionsForModel('seedance-2.5'),
    },
    {
        id: 'seedance-2.5-draft',
        chef: providers.bytedance,
        frameModeLabels: { ref: 'Omni Reference' },
        providers: [
            {
                ...providers.bytedance,
                model: baidu('seedance-2.5-api-draft-real'),
                modelBackup: [volcengine('seedance-2.5-api-draft')],
                // 样片固定按 480p 计费（含参考视频时走 480p 参考价）
                getCost: ({ duration, providerOptions }) => {
                    const inputDur = providerOptions?._media?.videoDurationSeconds ?? 0;
                    const totalDur = duration + inputDur;
                    const unit = inputDur > 0 ? usdRefCost480p : usdCost480p;
                    return totalDur * unit * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                },
                getPassCount: ({ duration, providerOptions }) => {
                    const inputDur = providerOptions?._media?.videoDurationSeconds ?? 0;
                    const totalDur = duration + inputDur;
                    const unit = inputDur > 0 ? rmbRefCost480p : rmbCost480p;
                    return totalDur * unit * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                },
            },
        ],
        configByMode: {
            none: {
                aspectRatios: ['9:16', '3:4', '1:1', '4:3', '16:9', '21:9'],
                durations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30],
                qualities: ['480p'],
                inlineMedia: {
                    image: { allow: false },
                    video: { allow: false },
                    audio: { allow: false },
                },
            },
            first: {
                aspectRatios: [],
                durations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30],
                qualities: ['480p'],
                inlineMedia: {
                    image: { allow: true, maxCount: 1, maxSize: '30MB', formats: ['image/png', 'image/jpeg'] },
                    video: { allow: false },
                    audio: { allow: false },
                },
            },
            first_last: {
                aspectRatios: [],
                durations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30],
                qualities: ['480p'],
                inlineMedia: {
                    image: { allow: true, maxCount: 2, maxSize: '30MB', formats: ['image/png', 'image/jpeg'] },
                    video: { allow: false },
                    audio: { allow: false },
                },
            },
            ref: {
                aspectRatios: ['match', '9:16', '3:4', '1:1', '4:3', '16:9', '21:9'],
                durations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30],
                qualities: ['480p'],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 30, maxSize: '30MB', formats: ['image/png', 'image/jpeg'] },
                    video: { allow: true, maxCount: 10, maxSize: '200MB', minDuration: '2s', maxDuration: '30s', minPixels: 409600, maxPixels: 8295044, formats: ['video/mp4', 'video/quicktime'] },
                    audio: { allow: true, maxCount: 10, maxSize: '15MB', minDuration: '2s', maxDuration: '30s', formats: ['audio/mpeg', 'audio/wav'] },
                    mediaDurationLimit: { enabled: true, maxTotalDuration: '30s' },
                    maxMediaCount: 20,
                    maxTotalCount: 50,
                },
            },
        },
        precheckByMode: {
            none: ['prompt'],
            first: ['prompt', 'image'],
            first_last: ['prompt', 'image2'],
            ref: ['prompt', 'image|video|audio'],
        },
        supportsEdit: true,
        supportsInput: ['t2v','first','first_last', 'reference'],
        priceIndicator: 'lowest',
        price: 'Dynamic',
        uiOptions: getUiOptionsForModel('seedance-2.5'),
    },
    {
        id: 'seedance-2.5-v2v',
        chef: providers.bytedance,
        frameModeLabels: { ref: 'Omni Reference' },
        providers: [
            {
                ...providers.bytedance,
                model: baidu('seedance-2.5-api-v2v-real'),
                modelBackup: [volcengine('seedance-2.5-api-v2v')],
                getCost: ({ duration, quality, providerOptions }) => {
                    const inputDur = providerOptions?._media?.videoDurationSeconds ?? 0;
                    const totalDur = inputDur > 0 ? inputDur : duration;
                    if (quality === '480p') return totalDur * usdRefCost480p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                    if (quality === '720p') return totalDur * usdRefCost720p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                    if (quality === '1080p') return totalDur * usdRefCost1080p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                    return totalDur * usdRefCost1080p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                },
                // 积分: 人民币
                getPassCount: ({ duration, quality, providerOptions }) => {
                    const inputDur = providerOptions?._media?.videoDurationSeconds ?? 0;
                    const totalDur = inputDur > 0 ? inputDur : duration;
                    if (quality === '480p') return totalDur * rmbRefCost480p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                    if (quality === '720p') return totalDur * rmbRefCost720p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                    if (quality === '1080p') return totalDur * rmbRefCost1080p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                    return totalDur * rmbRefCost1080p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                },
            },
        ],
        configByMode: {
            v2v: {
                aspectRatios: [],
                durations: [],
                qualities: ['480p', '720p', '1080p'],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 30, maxSize: '30MB', formats: ['image/png', 'image/jpeg'] },
                    video: { allow: true, maxCount: 1, maxSize: '200MB', minDuration: '4s', maxDuration: '30s', minPixels: 409600, maxPixels: 8295044, formats: ['video/mp4', 'video/quicktime'] },
                    audio: { allow: true, maxCount: 10, maxSize: '15MB', minDuration: '2s', maxDuration: '30s', formats: ['audio/mpeg', 'audio/wav'] },
                    maxMediaCount: 11,
                    maxTotalCount: 41,
                },
            },
        },
        precheckByMode: {
            v2v: ['prompt', 'video'],
        },
        supportsEdit: true,
        supportsInput: ['v2v'],
        priceIndicator: 'lowest',
        price: 'Dynamic',
        uiOptions: getUiOptionsForModel('seedance-2.5'),
    },
    {
        id: 'seedance-2.5-jimeng',
        chef: providers.bytedance,
        frameModeLabels: { ref: 'Omni Reference' },
        providers: [
            {
                ...providers.bytedance,
                model: dimensio('seedance-2.5'),
                modelBackup: [cool('seedance-2.5-cool')],
                // 积分: 美元
                getCost: ({ duration, quality, providerOptions }) => {
                    const inputDur = providerOptions?._media?.videoDurationSeconds ?? 0;
                    const totalDur = duration + inputDur;
                    if (inputDur > 0) {
                        if (quality === '480p') return totalDur * usdRefCost480p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                        if (quality === '720p') return totalDur * usdRefCost720p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                        if (quality === '1080p') return totalDur * usdRefCost1080p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                        return totalDur * usdRefCost1080p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                    } else {
                        if (quality === '480p') return totalDur * usdCost480p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                        if (quality === '720p') return totalDur * usdCost720p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                        if (quality === '1080p') return totalDur * usdCost1080p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                        return totalDur * usdCost1080p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                    }
                },
                // 积分: 人民币
                getPassCount: ({ duration, quality, providerOptions }) => {
                    const inputDur = providerOptions?._media?.videoDurationSeconds ?? 0;
                    const totalDur = duration + inputDur;
                    if (inputDur > 0) {
                        if (quality === '480p') return totalDur * rmbRefCost480p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                        if (quality === '720p') return totalDur * rmbRefCost720p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                        if (quality === '1080p') return totalDur * rmbRefCost1080p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                        return totalDur * rmbRefCost1080p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                    } else {
                        if (quality === '480p') return totalDur * rmbCost480p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                        if (quality === '720p') return totalDur * rmbCost720p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                        if (quality === '1080p') return totalDur * rmbCost1080p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                        return totalDur * rmbCost1080p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                    }
                },
            },
        ],
        configByMode: {
            none: {
                aspectRatios: ['9:16', '3:4', '1:1', '4:3', '16:9', '21:9'],
                durations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30],
                qualities: ['480p', '720p', '1080p'],
                inlineMedia: {
                    image: { allow: false },
                    video: { allow: false },
                    audio: { allow: false },
                },
            },
            first: {
                aspectRatios: [],
                durations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30],
                qualities: ['480p', '720p', '1080p'],
                inlineMedia: {
                    image: { allow: true, maxCount: 1, maxSize: '30MB', formats: ['image/png', 'image/jpeg'] },
                    video: { allow: false },
                    audio: { allow: false },
                },
            },
            first_last: {
                aspectRatios: [],
                durations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30],
                qualities: ['480p', '720p', '1080p'],
                inlineMedia: {
                    image: { allow: true, maxCount: 2, maxSize: '30MB', formats: ['image/png', 'image/jpeg'] },
                    video: { allow: false },
                    audio: { allow: false },
                },
            },
            ref: {
                aspectRatios: ['9:16', '3:4', '1:1', '4:3', '16:9', '21:9'],
                durations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30],
                qualities: ['480p', '720p', '1080p'],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 30, maxSize: '30MB', formats: ['image/png', 'image/jpeg'] },
                    video: { allow: true, maxCount: 10, maxSize: '50MB', minDuration: '2s', maxDuration: '30s', minPixels: 409600, maxPixels: 927408, formats: ['video/mp4','video/mov'] },
                    audio: { allow: true, maxCount: 10, maxSize: '15MB', minDuration: '2s', maxDuration: '30s', formats: ['audio/mpeg', 'audio/wav'] },
                    mediaDurationLimit: { enabled: true, maxTotalDuration: '30s' },
                    maxMediaCount: 20,
                    maxTotalCount: 50,
                },
            },
        },
        precheckByMode: {
            none: ['prompt'],
            first: ['prompt', 'image'],
            first_last: ['prompt', 'image2'],
            ref: ['prompt', 'image|video|audio'],
        },
        supportsEdit: true,
        supportsInput: ['t2v','first','first_last', 'reference'],
        priceIndicator: 'lowest',
        price: 'Dynamic',
        uiOptions: getUiOptionsForModel('seedance-2.5'),
    },
    {
        id: 'seedance-2.5-jimeng-long',
        chef: providers.bytedance,
        frameModeLabels: { ref: 'Omni Reference' },
        providers: [
            {
                ...providers.bytedance,
                model: dimensio('seedance-2.5-long'),
                // 积分: 美元
                getCost: ({ duration, quality, providerOptions }) => {
                    const inputDur = providerOptions?._media?.videoDurationSeconds ?? 0;
                    const totalDur = duration + inputDur;
                    if (inputDur > 0) {
                        if (quality === '480p') return totalDur * usdRefCost480p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                        if (quality === '720p') return totalDur * usdRefCost720p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                        if (quality === '1080p') return totalDur * usdRefCost1080p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                        return totalDur * usdRefCost1080p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                    } else {
                        if (quality === '480p') return totalDur * usdCost480p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                        if (quality === '720p') return totalDur * usdCost720p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                        if (quality === '1080p') return totalDur * usdCost1080p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                        return totalDur * usdCost1080p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                    }
                },
                // 积分: 人民币
                getPassCount: ({ duration, quality, providerOptions }) => {
                    const inputDur = providerOptions?._media?.videoDurationSeconds ?? 0;
                    const totalDur = duration + inputDur;
                    if (inputDur > 0) {
                        if (quality === '480p') return totalDur * rmbRefCost480p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                        if (quality === '720p') return totalDur * rmbRefCost720p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                        if (quality === '1080p') return totalDur * rmbRefCost1080p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                        return totalDur * rmbRefCost1080p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                    } else {
                        if (quality === '480p') return totalDur * rmbCost480p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                        if (quality === '720p') return totalDur * rmbCost720p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                        if (quality === '1080p') return totalDur * rmbCost1080p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                        return totalDur * rmbCost1080p * COST_FACTOR * SEEDANCE_2_5_COST_FACTOR;
                    }
                },
            },
        ],
        configByMode: {
            ref: {
                aspectRatios: ['9:16', '3:4', '1:1', '4:3', '16:9', '21:9'],
                durations: [30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157, 158, 159, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180],
                qualities: ['480p', '720p', '1080p'],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 30, maxSize: '30MB', formats: ['image/png', 'image/jpeg'] },
                    video: { allow: true, maxCount: 10, maxSize: '50MB', minDuration: '2s', maxDuration: '30s', minPixels: 409600, maxPixels: 927408, formats: ['video/mp4','video/mov'] },
                    audio: { allow: true, maxCount: 10, maxSize: '15MB', minDuration: '2s', maxDuration: '30s', formats: ['audio/mpeg', 'audio/wav'] },
                    mediaDurationLimit: { enabled: true, maxTotalDuration: '30s' },
                    maxMediaCount: 20,
                    maxTotalCount: 50,
                },
            },
        },
        precheckByMode: {
            ref: ['prompt', 'image|video|audio'],
        },
        supportsEdit: true,
        supportsInput: ['reference'],
        priceIndicator: 'lowest',
        price: 'Dynamic',
        uiOptions: getUiOptionsForModel('seedance-2.5'),
    },
    {
        id: 'seedance-2.0',
        chef: providers.bytedance,
        frameModeLabels: { ref: 'Omni Reference' },
        providers: [
            {
                ...providers.bytedance,
                model: dimensio('seedance-2.0'),
                modelBackup: [baidu('seedance-2.0-api-real'), volcengine('seedance-2.0')],
                // 积分: 美元
                getCost: ({ duration, quality, providerOptions }) => {
                    const inputDur = providerOptions?._media?.videoDurationSeconds ?? 0;
                    const totalDur = duration + inputDur;
                    if (inputDur > 0) {
                        if (quality === '480p') return totalDur * usdRefCost480p * COST_FACTOR;
                        if (quality === '720p') return totalDur * usdRefCost720p * COST_FACTOR;
                        if (quality === '1080p') return totalDur * usdRefCost1080p * COST_FACTOR;
                        if (quality === '4k') return totalDur * usdRefCost4k * COST_FACTOR;
                        return totalDur * usdRefCost4k * COST_FACTOR;
                    } else {
                        if (quality === '480p') return totalDur * usdCost480p * COST_FACTOR;
                        if (quality === '720p') return totalDur * usdCost720p * COST_FACTOR;
                        if (quality === '1080p') return totalDur * usdCost1080p * COST_FACTOR;
                        if (quality === '4k') return totalDur * usdCost4k * COST_FACTOR;
                        return totalDur * usdCost4k * COST_FACTOR;
                    }
                },
                // 积分: 人民币
                getPassCount: ({ duration, quality, providerOptions }) => {
                    const inputDur = providerOptions?._media?.videoDurationSeconds ?? 0;
                    const totalDur = duration + inputDur;
                    if (inputDur > 0) {
                        if (quality === '480p') return totalDur * rmbRefCost480p * COST_FACTOR;
                        if (quality === '720p') return totalDur * rmbRefCost720p * COST_FACTOR;
                        if (quality === '1080p') return totalDur * rmbRefCost1080p * COST_FACTOR;
                        if (quality === '4k') return totalDur * rmbRefCost4k * COST_FACTOR;
                        return totalDur * rmbRefCost4k * COST_FACTOR;
                    } else {
                        if (quality === '480p') return totalDur * rmbCost480p * COST_FACTOR;
                        if (quality === '720p') return totalDur * rmbCost720p * COST_FACTOR;
                        if (quality === '1080p') return totalDur * rmbCost1080p * COST_FACTOR;
                        if (quality === '4k') return totalDur * rmbCost4k * COST_FACTOR;
                        return totalDur * rmbCost4k * COST_FACTOR;
                    }
                },
            },
        ],
        configByMode: {
            none: {
                aspectRatios: ['9:16', '3:4', '1:1', '4:3', '16:9', '21:9'],
                durations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                qualities: ['480p', '720p', '1080p', '4k'],
                inlineMedia: {
                    image: { allow: false },
                    video: { allow: false },
                    audio: { allow: false },
                },
            },
            first: {
                aspectRatios: ['match', '9:16', '3:4', '1:1', '4:3', '16:9', '21:9'],
                durations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                qualities: ['480p', '720p', '1080p', '4k'],
                inlineMedia: {
                    image: { allow: true, maxCount: 1, maxSize: '30MB', formats: ['image/png', 'image/jpeg'] },
                    video: { allow: false },
                    audio: { allow: false },
                },
            },
            first_last: {
                aspectRatios: ['9:16', '3:4', '1:1', '4:3', '16:9', '21:9'],
                durations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                qualities: ['480p', '720p', '1080p', '4k'],
                inlineMedia: {
                    image: { allow: true, maxCount: 2, maxSize: '30MB', formats: ['image/png', 'image/jpeg'] },
                    video: { allow: false },
                    audio: { allow: false },
                },
            },
            ref: {
                aspectRatios: ['9:16', '3:4', '1:1', '4:3', '16:9', '21:9'],
                durations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                qualities: ['480p', '720p', '1080p', '4k'],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 9, maxSize: '30MB', formats: ['image/png', 'image/jpeg'] },
                    video: { allow: true, maxCount: 3, maxSize: '50MB', minDuration: '2s', maxDuration: '15.1s', minPixels: 409600, maxPixels: 927408, formats: ['video/mp4','video/mov'] },
                    audio: { allow: true, maxCount: 3, maxSize: '15MB', minDuration: '2s', maxDuration: '15.1s', formats: ['audio/mpeg'] },
                    mediaDurationLimit: { enabled: true, maxTotalDuration: '15.1s' },
                    maxMediaCount: 3,
                    maxTotalCount: 12,
                },
            },
        },
        precheckByMode: {
            none: ['prompt'],
            first: ['prompt', 'image'],
            first_last: ['prompt', 'image2'],
            ref: ['prompt', 'image|video'],
        },
        supportsEdit: true,
        supportsInput: ['t2v','first','first_last', 'reference'],
        priceIndicator: 'lowest',
        price: 'Dynamic',
        uiOptions: getUiOptionsForModel('seedance-2.0'),
    },
    {
        id: 'seedance-2.0-jimeng',
        chef: providers.bytedance,
        frameModeLabels: { ref: 'Omni Reference' },
        providers: [
            {
                ...providers.bytedance,
                model: dimensio('seedance-2.0'),
                modelBackup: [cool('seedance-2.0-cool')],
                // 积分: 美元
                getCost: ({ duration, quality, providerOptions }) => {
                    const inputDur = providerOptions?._media?.videoDurationSeconds ?? 0;
                    const totalDur = duration + inputDur;
                    if (inputDur > 0) {
                        if (quality === '480p') return totalDur * usdRefCost480p * COST_FACTOR;
                        if (quality === '720p') return totalDur * usdRefCost720p * COST_FACTOR;
                        if (quality === '1080p') return totalDur * usdRefCost1080p * COST_FACTOR;
                        if (quality === '4k' || quality === '2160p') return totalDur * usdRefCost4k * COST_FACTOR;
                        return totalDur * usdRefCost4k * COST_FACTOR;
                    } else {
                        if (quality === '480p') return totalDur * usdCost480p * COST_FACTOR;
                        if (quality === '720p') return totalDur * usdCost720p * COST_FACTOR;
                        if (quality === '1080p') return totalDur * usdCost1080p * COST_FACTOR;
                        if (quality === '4k' || quality === '2160p') return totalDur * usdCost4k * COST_FACTOR;
                        return totalDur * usdCost4k * COST_FACTOR;
                    }
                },
                // 积分: 人民币
                getPassCount: ({ duration, quality, providerOptions }) => {
                    const inputDur = providerOptions?._media?.videoDurationSeconds ?? 0;
                    const totalDur = duration + inputDur;
                    if (inputDur > 0) {
                        if (quality === '480p') return totalDur * rmbRefCost480p * COST_FACTOR;
                        if (quality === '720p') return totalDur * rmbRefCost720p * COST_FACTOR;
                        if (quality === '1080p') return totalDur * rmbRefCost1080p * COST_FACTOR;
                        if (quality === '4k' || quality === '2160p') return totalDur * rmbRefCost4k * COST_FACTOR;
                        return totalDur * rmbRefCost4k * COST_FACTOR;
                    } else {
                        if (quality === '480p') return totalDur * rmbCost480p * COST_FACTOR;
                        if (quality === '720p') return totalDur * rmbCost720p * COST_FACTOR;
                        if (quality === '1080p') return totalDur * rmbCost1080p * COST_FACTOR;
                        if (quality === '4k' || quality === '2160p') return totalDur * rmbCost4k * COST_FACTOR;
                        return totalDur * rmbCost4k * COST_FACTOR;
                    }
                },
            },
        ],
        configByMode: {
            none: {
                aspectRatios: ['9:16', '3:4', '1:1', '4:3', '16:9', '21:9'],
                durations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                qualities: ['480p', '720p', '1080p', '4k'],
                inlineMedia: {
                    image: { allow: false },
                    video: { allow: false },
                    audio: { allow: false },
                },
            },
            first: {
                aspectRatios: ['match', '9:16', '3:4', '1:1', '4:3', '16:9', '21:9'],
                durations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                qualities: ['480p', '720p', '1080p', '4k'],
                inlineMedia: {
                    image: { allow: true, maxCount: 1, maxSize: '30MB', formats: ['image/png', 'image/jpeg'] },
                    video: { allow: false },
                    audio: { allow: false },
                },
            },
            first_last: {
                aspectRatios: ['9:16', '3:4', '1:1', '4:3', '16:9', '21:9'],
                durations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                qualities: ['480p', '720p', '1080p', '4k'],
                inlineMedia: {
                    image: { allow: true, maxCount: 2, maxSize: '30MB', formats: ['image/png', 'image/jpeg'] },
                    video: { allow: false },
                    audio: { allow: false },
                },
            },
            ref: {
                aspectRatios: ['9:16', '3:4', '1:1', '4:3', '16:9', '21:9'],
                durations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                qualities: ['480p', '720p', '1080p', '4k'],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 9, maxSize: '30MB', formats: ['image/png', 'image/jpeg'] },
                    video: { allow: true, maxCount: 3, maxSize: '50MB', minDuration: '2s', maxDuration: '15.1s', minPixels: 409600, maxPixels: 927408, formats: ['video/mp4','video/mov'] },
                    audio: { allow: true, maxCount: 3, maxSize: '15MB', minDuration: '2s', maxDuration: '15.1s', formats: ['audio/mpeg'] },
                    mediaDurationLimit: { enabled: true, maxTotalDuration: '15.1s' },
                    maxMediaCount: 3,
                    maxTotalCount: 12,
                },
            },
        },
        precheckByMode: {
            none: ['prompt'],
            first: ['prompt', 'image'],
            first_last: ['prompt', 'image2'],
            ref: ['prompt', 'image|video'],
        },
        supportsEdit: true,
        supportsInput: ['t2v','first','first_last', 'reference'],
        priceIndicator: 'lowest',
        price: 'Dynamic',
        uiOptions: getUiOptionsForModel('seedance-2.0'),
    },
    {
        id: 'seedance-2.0-fast',
        chef: providers.bytedance,
        frameModeLabels: { ref: 'Omni Reference' },
        providers: [
            {
                ...providers.bytedance,
                model: dimensio('seedance-2.0-fast'),
                modelBackup: [baidu('seedance-2.0-fast-api-real'), tencent('seedance-2.0-fast')],
                // 积分: 美元
                getCost: ({ duration, quality, providerOptions }) => {
                    const inputDur = providerOptions?._media?.videoDurationSeconds ?? 0;
                    const totalDur = duration + inputDur;
                    if (inputDur > 0) {
                        if (quality === '480p') return totalDur * usdRefCost480pFast * COST_FACTOR;
                        if (quality === '720p') return totalDur * usdRefCost720pFast * COST_FACTOR;
                        return totalDur * usdRefCost720pFast * COST_FACTOR;
                    } else {
                        if (quality === '480p') return totalDur * usdCost480pFast * COST_FACTOR;
                        if (quality === '720p') return totalDur * usdCost720pFast * COST_FACTOR;
                        return totalDur * usdCost720pFast * COST_FACTOR;
                    }
                },
                // 积分: 人民币
                getPassCount: ({ duration, quality, providerOptions }) => {
                    const inputDur = providerOptions?._media?.videoDurationSeconds ?? 0;
                    const totalDur = duration + inputDur;
                    if (inputDur > 0) {
                        if (quality === '480p') return totalDur * rmbRefCost480pFast * COST_FACTOR;
                        if (quality === '720p') return totalDur * rmbRefCost720pFast * COST_FACTOR;
                        return totalDur * rmbRefCost720pFast;
                    } else {
                        if (quality === '480p') return totalDur * rmbCost480pFast * COST_FACTOR;
                        if (quality === '720p') return totalDur * rmbCost720pFast * COST_FACTOR;
                        return totalDur * rmbCost720pFast * COST_FACTOR;
                    }
                },
            },
        ],
        configByMode: {
            none: {
                aspectRatios: ['9:16', '3:4', '1:1', '4:3', '16:9', '21:9'],
                durations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                qualities: ['480p', '720p'],
                inlineMedia: {
                    image: { allow: false },
                    video: { allow: false },
                    audio: { allow: false },
                },
            },
            first: {
                aspectRatios: ['match', '9:16', '3:4', '1:1', '4:3', '16:9', '21:9'],
                durations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                qualities: ['480p', '720p'],
                inlineMedia: {
                    image: { allow: true, maxCount: 1, maxSize: '30MB', formats: ['image/png', 'image/jpeg'] },
                    video: { allow: false },
                    audio: { allow: false },
                },
            },
            first_last: {
                aspectRatios: ['9:16', '3:4', '1:1', '4:3', '16:9', '21:9'],
                durations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                qualities: ['480p', '720p'],
                inlineMedia: {
                    image: { allow: true, maxCount: 2, maxSize: '30MB', formats: ['image/png', 'image/jpeg'] },
                    video: { allow: false },
                    audio: { allow: false },
                },
            },
            ref: {
                aspectRatios: ['9:16', '3:4', '1:1', '4:3', '16:9', '21:9'],
                durations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                qualities: ['480p', '720p'],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 9, maxSize: '30MB', formats: ['image/png', 'image/jpeg'] },
                    video: { allow: true, maxCount: 3, maxSize: '50MB', minDuration: '2s', maxDuration: '15.1s', minPixels: 409600, maxPixels: 927408, formats: ['video/mp4','video/mov'] },
                    audio: { allow: true, maxCount: 3, maxSize: '15MB', minDuration: '2s', maxDuration: '15.1s', formats: ['audio/mpeg'] },
                    mediaDurationLimit: { enabled: true, maxTotalDuration: '15.1s' },
                    maxMediaCount: 3,
                    maxTotalCount: 12,
                },
            },
        },
        precheckByMode: {
            none: ['prompt'],
            first: ['prompt', 'image'],
            first_last: ['prompt', 'image2'],
            ref: ['prompt', 'image|video'],
        },
        supportsEdit: true,
        supportsInput: ['t2v','first','first_last', 'reference'],
        priceIndicator: 'lowest',
        price: 'Dynamic',
        uiOptions: getUiOptionsForModel('seedance-2.0-fast'),
    },
    {
        id: 'seedance-2.0-fast-jimeng',
        chef: providers.bytedance,
        frameModeLabels: { ref: 'Omni Reference' },
        providers: [
            {
                ...providers.bytedance,
                model: dimensio('seedance-2.0-fast'),
                modelBackup: [cool('seedance-2.0-fast-cool')],
                // 积分: 美元
                getCost: ({ duration, quality, providerOptions }) => {
                    const inputDur = providerOptions?._media?.videoDurationSeconds ?? 0;
                    const totalDur = duration + inputDur;
                    if (inputDur > 0) {
                        if (quality === '480p') return totalDur * usdRefCost480pFast * COST_FACTOR;
                        if (quality === '720p') return totalDur * usdRefCost720pFast * COST_FACTOR;
                        return totalDur * usdRefCost720pFast * COST_FACTOR;
                    } else {
                        if (quality === '480p') return totalDur * usdCost480pFast * COST_FACTOR;
                        if (quality === '720p') return totalDur * usdCost720pFast * COST_FACTOR;
                        return totalDur * usdCost720pFast * COST_FACTOR;
                    }
                },
                // 积分: 人民币
                getPassCount: ({ duration, quality, providerOptions }) => {
                    const inputDur = providerOptions?._media?.videoDurationSeconds ?? 0;
                    const totalDur = duration + inputDur;
                    if (inputDur > 0) {
                        if (quality === '480p') return totalDur * rmbRefCost480pFast * COST_FACTOR;
                        if (quality === '720p') return totalDur * rmbRefCost720pFast * COST_FACTOR;
                        return totalDur * rmbRefCost720pFast * COST_FACTOR;
                    } else {
                        if (quality === '480p') return totalDur * rmbCost480pFast * COST_FACTOR;
                        if (quality === '720p') return totalDur * rmbCost720pFast * COST_FACTOR;
                        return totalDur * rmbCost720pFast * COST_FACTOR;
                    }
                },
            },
        ],
        configByMode: {
            none: {
                aspectRatios: ['9:16', '3:4', '1:1', '4:3', '16:9', '21:9'],
                durations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                qualities: ['480p', '720p'],
                inlineMedia: {
                    image: { allow: false },
                    video: { allow: false },
                    audio: { allow: false },
                },
            },
            first: {
                aspectRatios: ['match', '9:16', '3:4', '1:1', '4:3', '16:9', '21:9'],
                durations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                qualities: ['480p', '720p'],
                inlineMedia: {
                    image: { allow: true, maxCount: 1, maxSize: '30MB', formats: ['image/png', 'image/jpeg'] },
                    video: { allow: false },
                    audio: { allow: false },
                },
            },
            first_last: {
                aspectRatios: ['9:16', '3:4', '1:1', '4:3', '16:9', '21:9'],
                durations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                qualities: ['480p', '720p'],
                inlineMedia: {
                    image: { allow: true, maxCount: 2, maxSize: '30MB', formats: ['image/png', 'image/jpeg'] },
                    video: { allow: false },
                    audio: { allow: false },
                },
            },
            ref: {
                aspectRatios: ['9:16', '3:4', '1:1', '4:3', '16:9', '21:9'],
                durations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                qualities: ['480p', '720p'],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 9, maxSize: '30MB', formats: ['image/png', 'image/jpeg'] },
                    video: { allow: true, maxCount: 3, maxSize: '50MB', minDuration: '2s', maxDuration: '15.1s', minPixels: 409600, maxPixels: 927408, formats: ['video/mp4','video/mov'] },
                    audio: { allow: true, maxCount: 3, maxSize: '15MB', minDuration: '2s', maxDuration: '15.1s', formats: ['audio/mpeg'] },
                    mediaDurationLimit: { enabled: true, maxTotalDuration: '15.1s' },
                    maxMediaCount: 3,
                    maxTotalCount: 12,
                },
            },
        },
        precheckByMode: {
            none: ['prompt'],
            first: ['prompt', 'image'],
            first_last: ['prompt', 'image2'],
            ref: ['prompt', 'image|video'],
        },
        supportsEdit: true,
        supportsInput: ['t2v','first','first_last', 'reference'],
        priceIndicator: 'lowest',
        price: 'Dynamic',
        uiOptions: getUiOptionsForModel('seedance-2.0-fast'),
    },
    {
        id: 'seedance-2.0-mini',
        chef: providers.bytedance,
        frameModeLabels: { ref: 'Omni Reference' },
        providers: [
            {
                ...providers.bytedance,
                model: dimensio('seedance-2.0-mini'),
                modelBackup: [baidu('seedance-2.0-mini-api-real'), tencent('seedance-2.0-mini')],
                // 积分: 美元
                getCost: ({ duration, quality, providerOptions }) => {
                    const inputDur = providerOptions?._media?.videoDurationSeconds ?? 0;
                    const totalDur = duration + inputDur;
                    if (inputDur > 0) {
                        if (quality === '480p') return totalDur * usdRefCost480pMini * COST_FACTOR;
                        if (quality === '720p') return totalDur * usdRefCost720pMini * COST_FACTOR;
                        return totalDur * usdRefCost720pMini * COST_FACTOR;
                    } else {
                        if (quality === '480p') return totalDur * usdCost480pMini * COST_FACTOR;
                        if (quality === '720p') return totalDur * usdCost720pMini * COST_FACTOR;
                        return totalDur * usdCost720pMini * COST_FACTOR;
                    }
                },
                // 积分: 人民币
                getPassCount: ({ duration, quality, providerOptions }) => {
                    const inputDur = providerOptions?._media?.videoDurationSeconds ?? 0;
                    const totalDur = duration + inputDur;
                    if (inputDur > 0) {
                        if (quality === '480p') return totalDur * rmbRefCost480pMini * COST_FACTOR;
                        if (quality === '720p') return totalDur * rmbRefCost720pMini * COST_FACTOR;
                        return totalDur * rmbRefCost720pMini;
                    } else {
                        if (quality === '480p') return totalDur * rmbCost480pMini * COST_FACTOR;
                        if (quality === '720p') return totalDur * rmbCost720pMini * COST_FACTOR;
                        return totalDur * rmbCost720pMini * COST_FACTOR;
                    }
                },
            },
        ],
        configByMode: {
            none: {
                aspectRatios: ['9:16', '3:4', '1:1', '4:3', '16:9', '21:9'],
                durations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                qualities: ['480p', '720p'],
                inlineMedia: {
                    image: { allow: false },
                    video: { allow: false },
                    audio: { allow: false },
                },
            },
            first: {
                aspectRatios: ['match', '9:16', '3:4', '1:1', '4:3', '16:9', '21:9'],
                durations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                qualities: ['480p', '720p'],
                inlineMedia: {
                    image: { allow: true, maxCount: 1, maxSize: '30MB', formats: ['image/png', 'image/jpeg'] },
                    video: { allow: false },
                    audio: { allow: false },
                },
            },
            first_last: {
                aspectRatios: ['9:16', '3:4', '1:1', '4:3', '16:9', '21:9'],
                durations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                qualities: ['480p', '720p'],
                inlineMedia: {
                    image: { allow: true, maxCount: 2, maxSize: '30MB', formats: ['image/png', 'image/jpeg'] },
                    video: { allow: false },
                    audio: { allow: false },
                },
            },
            ref: {
                aspectRatios: ['9:16', '3:4', '1:1', '4:3', '16:9', '21:9'],
                durations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                qualities: ['480p', '720p'],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 9, maxSize: '30MB', formats: ['image/png', 'image/jpeg'] },
                    video: { allow: true, maxCount: 3, maxSize: '50MB', minDuration: '2s', maxDuration: '15.1s', minPixels: 409600, maxPixels: 927408, formats: ['video/mp4','video/mov'] },
                    audio: { allow: true, maxCount: 3, maxSize: '15MB', minDuration: '2s', maxDuration: '15.1s', formats: ['audio/mpeg'] },
                    mediaDurationLimit: { enabled: true, maxTotalDuration: '15.1s' },
                    maxMediaCount: 3,
                    maxTotalCount: 12,
                },
            },
        },
        precheckByMode: {
            none: ['prompt'],
            first: ['prompt', 'image'],
            first_last: ['prompt', 'image2'],
            ref: ['prompt', 'image|video'],
        },
        supportsEdit: true,
        supportsInput: ['t2v','first','first_last', 'reference'],
        priceIndicator: 'lowest',
        price: 'Dynamic',
        uiOptions: getUiOptionsForModel('seedance-2.0-mini'),
    },
    {
        id: 'seedance-2.0-mini-jimeng',
        chef: providers.bytedance,
        frameModeLabels: { ref: 'Omni Reference' },
        providers: [
            {
                ...providers.bytedance,
                model: dimensio('seedance-2.0-mini'),
                modelBackup: [cool('seedance-2.0-mini-cool')],
                // 积分: 美元
                getCost: ({ duration, quality, providerOptions }) => {
                    const inputDur = providerOptions?._media?.videoDurationSeconds ?? 0;
                    const totalDur = duration + inputDur;
                    if (inputDur > 0) {
                        if (quality === '480p') return totalDur * usdRefCost480pMini * COST_FACTOR;
                        if (quality === '720p') return totalDur * usdRefCost720pMini * COST_FACTOR;
                        return totalDur * usdRefCost720pMini * COST_FACTOR;
                    } else {
                        if (quality === '480p') return totalDur * usdCost480pMini * COST_FACTOR;
                        if (quality === '720p') return totalDur * usdCost720pMini * COST_FACTOR;
                        return totalDur * usdCost720pMini * COST_FACTOR;
                    }
                },
                // 积分: 人民币
                getPassCount: ({ duration, quality, providerOptions }) => {
                    const inputDur = providerOptions?._media?.videoDurationSeconds ?? 0;
                    const totalDur = duration + inputDur;
                    if (inputDur > 0) {
                        if (quality === '480p') return totalDur * rmbRefCost480pMini * COST_FACTOR;
                        if (quality === '720p') return totalDur * rmbRefCost720pMini * COST_FACTOR;
                        return totalDur * rmbRefCost720pMini * COST_FACTOR;
                    } else {
                        if (quality === '480p') return totalDur * rmbCost480pMini * COST_FACTOR;
                        if (quality === '720p') return totalDur * rmbCost720pMini * COST_FACTOR;
                        return totalDur * rmbCost720pMini * COST_FACTOR;
                    }
                },
            },
        ],
        configByMode: {
            none: {
                aspectRatios: ['9:16', '3:4', '1:1', '4:3', '16:9', '21:9'],
                durations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                qualities: ['480p', '720p'],
                inlineMedia: {
                    image: { allow: false },
                    video: { allow: false },
                    audio: { allow: false },
                },
            },
            first: {
                aspectRatios: ['match', '9:16', '3:4', '1:1', '4:3', '16:9', '21:9'],
                durations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                qualities: ['480p', '720p'],
                inlineMedia: {
                    image: { allow: true, maxCount: 1, maxSize: '30MB', formats: ['image/png', 'image/jpeg'] },
                    video: { allow: false },
                    audio: { allow: false },
                },
            },
            first_last: {
                aspectRatios: ['9:16', '3:4', '1:1', '4:3', '16:9', '21:9'],
                durations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                qualities: ['480p', '720p'],
                inlineMedia: {
                    image: { allow: true, maxCount: 2, maxSize: '30MB', formats: ['image/png', 'image/jpeg'] },
                    video: { allow: false },
                    audio: { allow: false },
                },
            },
            ref: {
                aspectRatios: ['9:16', '3:4', '1:1', '4:3', '16:9', '21:9'],
                durations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                qualities: ['480p', '720p'],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 9, maxSize: '30MB', formats: ['image/png', 'image/jpeg'] },
                    video: { allow: true, maxCount: 3, maxSize: '50MB', minDuration: '2s', maxDuration: '15.1s', minPixels: 409600, maxPixels: 927408, formats: ['video/mp4','video/mov'] },
                    audio: { allow: true, maxCount: 3, maxSize: '15MB', minDuration: '2s', maxDuration: '15.1s', formats: ['audio/mpeg'] },
                    mediaDurationLimit: { enabled: true, maxTotalDuration: '15.1s' },
                    maxMediaCount: 3,
                    maxTotalCount: 12,
                },
            },
        },
        precheckByMode: {
            none: ['prompt'],
            first: ['prompt', 'image'],
            first_last: ['prompt', 'image2'],
            ref: ['prompt', 'image|video'],
        },
        supportsEdit: true,
        supportsInput: ['t2v','first','first_last', 'reference'],
        priceIndicator: 'lowest',
        price: 'Dynamic',
        uiOptions: getUiOptionsForModel('seedance-2.0-mini'),
    },
];